var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomnav1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Home Page",
    width: 30,
    height: 30,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_686_13099",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_686_13099",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACjElEQVR4nO3cv49MYRTG8ZOQsQpCi6go6GjWf0BDL6HQqPwotbod/AUqxYqein/Aj8aqFFQ2zJbCJkiIr9zNLSbD7oyZe9/3vOd9PuVm9t7nPHNzd0/uZMxEREREZAywBNwBRsAGMGx+Nv4aWRBwCHjJ314DRxc9vthWyaeAD2zvE7Cssha7ki8D35muec2lGY85GLsFTb5hze1oUM2bBuwC7vH/7ja/O+XYTZk7GVoNgH3AY+b3FDiww/Enr+RJGxYdcAx4y+LeASe2OcdUFhlwFvhMd74C5/9xnnqLBq4CP+neL+CW1V40sAd4QP8eAXvbc05llSwhfdlabmZ5oUUBLLf/t6Y20zktAuAi8A3HLMASMqQAVvgS8oRCWImA4x0tIclYaXpYQpKwkgA324WhOFbQk5BVyrZknmVYQvri98kNcBpYJ44RcMY8KWEJmdMP4ErufotaQhZ0H9idq+T9JS0hHXgGHExdcnFLSEfeAydTlXyuxCWk4yc3F/ouudglpGO/gdt9FNx8FuJh12kDWO30cyDASu6JHFvpsugcT0NKMVLRaXzssugalhIXt45BW7ZuITk+FEllLBcqYyo6DRWdiIpOREUnoqITUdGJqOhEQhVtFWQLNQyOs4UaBsfZQg2D42yhhsFxtlDD4DhbqGFwnC3UMDjOFmoYHGcLNQyOs4UaBsfZQg2D42yhhsFxtlDD4DhbqGFwnC3UMDjOFmoYHGcLNQyOs4UaBsfZQg2D42yhhsFxtlDD4DhbqGFwnC3UMDjONs8wm9TjS86iX1GPFzmLvkE9ruX+btE3xLeW/ZvSgSPBy14DDpsH7ZV9vbmPBfkDuQk8b24X2a9kERERERERERHz5w8J5kAMAqGLzAAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomnav1);
export default __webpack_public_path__ + "static/media/bottomnav-1.3175c17a6f2cd9430caf2bd87105c2ae.svg";
export { ForwardRef as ReactComponent };